 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062248695_COVER from '@/components/text/9780062248695_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062248695_TITLEPAGE from '@/components/text/9780062248695_Titlepage'
 import TEXT9780062248695_DEDICATION from '@/components/text/9780062248695_Dedication'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780062248695_PREFACE from '@/components/text/9780062248695_Preface'
 import TEXT9780062248695_PART_1 from '@/components/text/9780062248695_Part_1'
 import TEXT9780062248695_CHAPTER_1 from '@/components/text/9780062248695_Chapter_1'
 import TEXT9780062248695_CHAPTER_2 from '@/components/text/9780062248695_Chapter_2'
 import TEXT9780062248695_CHAPTER_3 from '@/components/text/9780062248695_Chapter_3'
 import TEXT9780062248695_PART_2 from '@/components/text/9780062248695_Part_2'
 import TEXT9780062248695_CHAPTER_4 from '@/components/text/9780062248695_Chapter_4'
 import TEXT9780062248695_CHAPTER_5 from '@/components/text/9780062248695_Chapter_5'
 import TEXT9780062248695_CHAPTER_6 from '@/components/text/9780062248695_Chapter_6'
 import TEXT9780062248695_PART_3 from '@/components/text/9780062248695_Part_3'
 import TEXT9780062248695_CHAPTER_7 from '@/components/text/9780062248695_Chapter_7'
 import TEXT9780062248695_CHAPTER_8 from '@/components/text/9780062248695_Chapter_8'
 import TEXT9780062248695_CHAPTER_9 from '@/components/text/9780062248695_Chapter_9'
 import TEXT9780062248695_EPILOGUE from '@/components/text/9780062248695_Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062248695_NOTES from '@/components/text/9780062248695_Notes'
 import TEXT9780062248695_ILLUSTRATION_CREDIT from '@/components/text/9780062248695_Illustration_Credit'
 import TEXT9780062248695_INDEX from '@/components/text/9780062248695_Index'
 import TEXT9780062248695_PHOTO_SECTION from '@/components/text/9780062248695_Photo_section'
 import TEXTEDGES_ANNOUNCEMENT from '@/components/text/Edges_Announcement'
 import TEXTEDGES_CHAPTER_1 from '@/components/text/Edges_Chapter_1'
 import TEXTEDGES_NOTES from '@/components/text/Edges_Notes'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXT9780062248695_PRAISE from '@/components/text/9780062248695_Praise'
 import TEXT9780062248695_ALSO_BY from '@/components/text/9780062248695_Also_By'
 import TEXT9780062248695_AD_CARD from '@/components/text/9780062248695_Ad_card'
 import TEXT9780062248695_CREDITS from '@/components/text/9780062248695_Credits'
 import TEXT9780062248695_COPYRIGHT from '@/components/text/9780062248695_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780062248695_Preface",
 			"name" : "text/9780062248695_Preface",
 			"component" : TEXT9780062248695_PREFACE
 		},
 		{
 			"path" : "/text/9780062248695_Part_1",
 			"name" : "text/9780062248695_Part_1",
 			"component" : TEXT9780062248695_PART_1
 		},
 		{
 			"path" : "/text/9780062248695_Chapter_1",
 			"name" : "text/9780062248695_Chapter_1",
 			"component" : TEXT9780062248695_CHAPTER_1
 		},
 		{
 			"path" : "/text/9780062248695_Chapter_2",
 			"name" : "text/9780062248695_Chapter_2",
 			"component" : TEXT9780062248695_CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js